/** Захиалж болох хамгийн бага тоо ширхэг */
export const MIN_PRODUCT_UNIT = 1;

/**
 * Оруулсан тоо ширхэгийг боломжит хязгаарт багтаана.
 *
 * antd-ийн `InputNumber` нь `min`/`max`-аар үүнийг өөрөө хийдэг ч ЧИМЭЭГҮЙ
 * хийдэг: хэрэглэгч 0 эсвэл сөрөг тоо бичээд фокус алдахад 1 болчихдог, 999
 * бичихэд үлдэгдэл хүртэл хумигддаг ч ямар ч мэдэгдэл гардаггүй. Улмаар
 * хэрэглэгч өөрийн бичсэн тоогоор захиалга үүссэн гэж андуурдаг байв.
 *
 * Тиймээс хумилтыг өөрсдөө хийж, юу өөрчлөгдсөнийг `notice`-оор буцаана.
 *
 * Хоосон, бутархай, тоо биш утгыг формын дүрмүүд аль хэдийн блокладаг тул энд
 * хөндөхгүй — тэдгээрийг хумивал хэрэглэгчийн алдаа далдлагдана.
 *
 * @param {*} value хэрэглэгчийн оруулсан утга
 * @param {number} [availableStock] боломжит үлдэгдэл (мэдэгдэхгүй бол дээд
 *   хязгаар тавихгүй)
 * @returns {{ value: *, notice: string|null }} `notice` нь `null` бол утга
 *   өөрчлөгдөөгүй
 */
export const clampProductUnit = (value, availableStock) => {
  const unchanged = { value, notice: null };

  if (typeof value !== 'number' || !Number.isInteger(value)) return unchanged;

  const max = Number.isInteger(availableStock) ? availableStock : null;
  // Үлдэгдэлгүй бараан дээр 1-ийг шаардвал талбар хэзээ ч хүчинтэй болохгүй
  const min = max === 0 ? 0 : MIN_PRODUCT_UNIT;

  if (value < min) {
    return { value: min, notice: `Тоо ширхэг хамгийн багадаа ${min} байх ёстой.` };
  }

  if (max !== null && value > max) {
    return { value: max, notice: `Боломжит үлдэгдэл ${max} ширхэг.` };
  }

  return unchanged;
};
